import type { GenderType } from '@/types/common';
import { GenderTypes } from '@/types/common';

export const GENDER_LABELS: Record<GenderType, string> = {
  [GenderTypes.FEMALE]: 'Female',
  [GenderTypes.MALE]: 'Male',
  [GenderTypes.UNSPECIFIED]: 'Unspecified',
};

export const GENDER_OPTIONS = [
  {
    value: GenderTypes.FEMALE,
    label: GENDER_LABELS[GenderTypes.FEMALE],
  },
  {
    value: GenderTypes.MALE,
    label: GENDER_LABELS[GenderTypes.MALE],
  },
  {
    value: GenderTypes.UNSPECIFIED,
    label: GENDER_LABELS[GenderTypes.UNSPECIFIED],
  },
];